import { useContext, useState } from "react";
import useTranslator from "../../../hooks/useTranslator";
import * as Joi from "joi-browser";
import { Modal } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import LandLordContext from "../../../context/landlord/LandLordContext";
import { haveValue } from "../../../helper/common";

const AddSubLLModal = (props) => {
  const landLordContext = useContext(LandLordContext);
  const { addSubLL } = landLordContext;
  const { showAddSubLL, handleCloseModal } = props;
  const { _t } = useTranslator();
  const schema = {
    fname_companyName: Joi.string().min(1).required().label("First name"),
    lname: Joi.string().min(1).required().label("Last name"),
    phone: Joi.string().allow("", null).label("Phone"),
    email: Joi.string().email().required().label("Email"),
    isAdmin: Joi.boolean(),
  };
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [landlordProfile, setLandlordProfile] = useState({
    fname_companyName: "",
    lname: "",
    phone: "",
    email: "",
    isAdmin: false,
  });
  const [errors, setErrors] = useState({});

  const getErrorMessage = (field, message) => {
    switch (field) {
      case "fname_companyName":
        return _t("firstNameOrCompanyNameIsRequired");
      case "lname":
        return _t("lastNameIsRequired");
      case "phone":
        return _t("phoneIsRequired");
      case "email":
        return message === "string.email"
          ? _t("pleaseEnterValidEmail")
          : _t("emailIsRequired");
      default:
        return message;
    }
  };

  const changeLandlordPhoneNumber = (value) => {
    setPhoneNumber(value);
    setLandlordProfile((prev) => ({ ...prev, phone: value }));
    const { phone: _, ...updatedState } = errors; // Destructure and remove the key
    setErrors(updatedState);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const { [name]: _, ...updatedState } = errors; // Destructure and remove the key
    setErrors(updatedState);
    setLandlordProfile((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateForm = () => {
    const { error } = Joi.validate(landlordProfile, schema, {
      abortEarly: false,
    });
    if (error) {
      const newErrors = error.details.reduce((acc, curr) => {
        acc[curr.path[0]] = getErrorMessage(curr.path[0], curr.type);
        return acc;
      }, {});
      setErrors(newErrors);
      return false;
    }
    setErrors({});
    return true;
  };

  const handleAddSubLL = () => {
    if (validateForm()) {
      addSubLL(landlordProfile)
        .then((res) => {
          if (haveValue(res)) {
            handleCloseModal();
          }
          console.log("done", res);
        })
        .catch((err) => {
          console.log("Error inside handleAddSubLL");
        });
    }
  };
  return (
    <>
      <Modal
        show={showAddSubLL}
        onHide={handleCloseModal}
        centered
        className="newmodalui asguarantor modal-xl add-landlord-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4>{_t("addSubLandlord")}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <label className="col-lg-6 mt-3">
              <h6>{_t("firstName")}</h6>
              <input
                type="text"
                name="fname_companyName"
                onChange={handleInputChange}
                className="form-control"
                placeholder={_t("enterFirstName")}
              />
              {errors.fname_companyName && <p>{errors.fname_companyName}</p>}
            </label>
            <label className="col-lg-6 mt-3">
              <h6>{_t("lastName")}</h6>
              <input
                type="text"
                name="lname"
                onChange={handleInputChange}
                className="form-control"
                placeholder={_t("enterLastName")}
              />
              {errors.lname && <p>{errors.lname}</p>}
            </label>
            <label className="col-lg-6 mt-3">
              <h6>{_t("email")}</h6>
              <input
                type="email"
                name="email"
                onChange={handleInputChange}
                className="form-control"
                placeholder={_t("enterEmail")}
              />
              {errors.email && <p>{errors.email}</p>}
            </label>
            <label className="col-lg-6 mt-3">
              <h6>{_t("phoneNumber")}</h6>
              <PhoneInput
                className="custom-input phone_input"
                international
                country="es"
                value={phoneNumber}
                onChange={changeLandlordPhoneNumber}
                placeholder={_t("enterPhoneNumber")}
              />{" "}
              {errors.phone && <p>{errors.phone}</p>}
            </label>
            <label>
              <input
                type="checkbox"
                name="isAdmin"
                onChange={(e) =>
                  setLandlordProfile((prevData) => ({
                    ...prevData,
                    isAdmin: !prevData.isAdmin,
                  }))
                }
                checked={landlordProfile?.isAdmin}
              />{" "}
              {_t(
                "addAsAdminLL",
                "When adding a Sub LL to an agency to ask if this is a admin or not."
              )}
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btngreen add-landlord-submit"
            onClick={handleAddSubLL}
          >
            {_t("submit")}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddSubLLModal;
